<template>
  <el-container>
    <div class="Login">
      <div class="LoginBox">
        <div class="BoxLes">
          <div class="LesCons">
            <h1>欢迎登录</h1>
            <h2><span>小盒BOSS后台管理</span>系统</h2>
            <div class="LesForm">
              <div class="Lis">
                <div class="Icon">
                  <img src="../assets/per.png" alt="">
                </div>
                <input type="text" v-model="ruleForm.username" placeholder="请输入账号"/>
              </div>
              <div class="Lis">
                <div class="Icon">
                  <img src="../assets/psd.png" alt="">
                </div>
                <input type="password" v-model="ruleForm.password" placeholder="请输入密码"/>
              </div>
            </div>
            <div class="Sign" @click="login('ruleForm')" >登录</div>
            <a style="color: #175ceb;display: block;text-align: center;position: absolute;bottom: 20px;width: 100%;left: 0;" target="_blank" href="https://www.996w.com/">联系我们</a>
          </div>
        </div>
        <div class="BoxRis">
          <el-carousel>
            <el-carousel-item v-for="(item,key) in swiperCons" :key="key">
              <a target="_blank" href="https://www.996w.com/"><img :src="item"></a>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="AboutUs">
        <a target="_blank" href="http://www.qqiv.com/">腾讯企业邮箱</a>
        <a target="_blank" href="https://www.996w.com/index/Article/index.html?cid=HBzpAtNyE6&visitPower=iykwbepxar">网站建设</a>
        <a target="_blank" href="https://www.996w.com/index/Article/index.html?cid=pdrAhixuBz&visitPower=iykwbepxar">小程序开发</a>
        <a target="_blank" href="https://www.996w.com/index/Article/index.html?cid=lTGkg6twkC&visitPower=roigaigqdl">系统开发</a>
        <a target="_blank" href="https://www.996w.com/index/Article/index.html?cid=kPlJcTcBqM&visitPower=iykwbepxar">网站推广</a>
        <a target="_blank" href="https://www.996w.com/index/Articlelist/index.html?cid=iEFrgvpNe4">数据安全系统</a>
        <a target="_blank" href="https://www.996w.com">联系我们</a>
      </div>
      <div class="CopyRight">
        <div>版权所有 © 2013-2023 <a target="_blank" href="https://www.996w.com">广东企拓·九六网</a> All rights reserved.       <a target="_blank" href="https://beian.miit.gov.cn">粤ICP备17088737号</a>       公司官网：<a target="_blank" href="https://www.996w.com">996w.com</a><a style="padding-left:25px">联系电话：400-119-0035</a></div>
      </div>
    </div>
  </el-container>
  </template>
  <script lang="ts" setup>
  import { reactive, ref } from 'vue'
  import { useAlone } from '@/store';
  import pinia from '@/store/store';
  import {useRouter} from 'vue-router'
  import api from '@/api/index'
  import { ElMessage, ElLoading, FormInstance, FormRules } from 'element-plus'
  
  const alone = useAlone(pinia)
  const router = useRouter()
  
  const ruleFormRef = ref<FormInstance>()
  const rules = reactive<FormRules>({
    username: [
      { required: true, message: '请输入用户名', trigger: 'blur' },
    ],
    password: [
      { required: true, message: '请输入密码', trigger: 'blur' },
    ],
  })

  const swiperCons = reactive([
    require("../assets/lb1.jpg"),
    require("../assets/lb2.jpg"),
    require("../assets/lb3.jpg"),
    require("../assets/lb4.jpg")
  ]);
  
  const ruleForm = reactive({
    username:'',
    password:'',
  });
  const login = (formName:any) => {
    const loading = ElLoading.service({
      lock: true,
    })
    api.aloneApi.login(ruleForm).then((res:any) => {
        if (res.code === 200) {
            localStorage.setItem('userId', res.data.id)
            localStorage.setItem('username', ruleForm.username)
            alone.setLoginStatus(true)
            setTimeout(() => {
              router.push("/statistics");
              ElMessage({
                message: res.message,
                type: 'success',
              })
              loading.close()
            }, 1000)
        } else if (res.code == 1002) {
          alone.setLoginStatus(true)
          // 当前已经登录
          router.push({path: '/statistics'})
        }else{
          setTimeout(() => {
            loading.close()
            ElMessage.error(res.message)
          }, 1000)
        }
    }).catch((res:any) => {
      loading.close()
      ElMessage.error(res.message);
    })
  }
  </script>
  <style>
body,h1,h2{margin: 0;}
div{font-family: "思源黑体";}
.Login{width: 100vw;height: 100vh;background-image: url("../assets/bg.jpg");background-size: cover;background-position: center center;display: flex;justify-content: center;position:relative;background-repeat: no-repeat;}
.Login .LoginBox{width: 1280px;height: 650px;background-color: #fff;border-radius: 8px;box-shadow: 0 0 20px 0px rgba(0,0,0,.1);padding: 10px;box-sizing: border-box;display:flex;margin-top:5%}
.Login .LoginBox .BoxLes{width: 600px;text-align:left;position: relative;}
.Login .LoginBox .BoxLes .LesCons{display: flex;width: 410px;margin: auto;flex-direction: column;}
.Login .LoginBox .BoxLes .LesCons h1{font-size: 36px;line-height:36px;padding:90px 0 20px;}
.Login .LoginBox .BoxLes .LesCons h2{font-size: 32px;line-height:32px;}
.Login .LoginBox .BoxLes .LesCons h2 span{color: #175ceb;}
.Login .LoginBox .BoxLes .LesCons .LesForm{margin: 50px 0 55px;}
.Login .LoginBox .BoxLes .LesCons .LesForm .Lis{width: 100%;line-height: 50px;box-sizing: border-box;height: 50px;display: flex;overflow:hidden;position:relative;margin-bottom:25px;}
.Login .LoginBox .BoxLes .LesCons .LesForm .Lis .Icon{width: 50px;height: 50px;display: flex;align-items: center;justify-content: center;position:absolute;}
.Login .LoginBox .BoxLes .LesCons .LesForm .Lis .Icon img{display: block}
.Login .LoginBox .BoxLes .LesCons .LesForm .Lis input{outline:0;border: 1px solid  #ccc;box-sizing:border-box;padding:0;width:100%;border-radius: 6px;padding-left:50px;}
.Login .LoginBox .BoxLes .LesCons .LesForm .Lis input:focus{border:1px solid #175ceb;}
.Login .LoginBox .BoxLes .LesCons .LesForm .Lis input::placeholder{font-size:16px;}
.Login .LoginBox .BoxLes .LesCons .Sign{width:100%;background:#175ceb;color:#fff;line-height:50px;text-align:center;border-radius:25px;cursor:pointer;} 
.Login .LoginBox .BoxRis{width:660px;height:100%;box-sizing: border-box;border-top-right-radius:6px;border-bottom-right-radius:6px;overflow:hidden;}
.Login .LoginBox .BoxRis .el-carousel,.Login .LoginBox .BoxRis .el-carousel .el-carousel__container{height:100%;}




.Login .AboutUs{position:absolute;bottom:70px;line-height:45px;}
.Login .AboutUs a{padding: 0 7px;color:#666;font-size:14px;}





.Login .CopyRight{position:absolute;bottom:0;width:100%;height:70px;background:#f8f8f8;text-align: center;}
.Login .CopyRight>div{line-height:70px;font-size:14px;color:#666;}
.Login .CopyRight>div a{color:#666;text-decoration:none;}
.Login .CopyRight>div a:nth-of-type(2){padding:0 25px}
  </style>